import React, { useEffect, useState, Fragment, useContext } from 'react';
import Layout from 'components/sales/layout/layout';
import localization from 'assets/localization/localization';
import { Button } from 'react-bootstrap';
import Images from 'assets/images/imageData';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import ModalPop from 'components/sales/modal/modal';
import { Link } from 'react-router-dom';
import FormSection from 'components/sales/formSection/formSection';
import Regex from 'services/utils/regex/Regex';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import DocumentView from 'components/sales/downloadDocView/documentView';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import Checkbox from 'components/sales/Input/checkbox/checkbox';
import Tags from 'components/sales/formSection/materialHardware/tags';
import DistanceCalculator from "../../DistanceCalculator/Calculator";
import {toast} from "react-toastify";
import axios from "../../../services/interceptor/Interceptor";
import Config from "services/config/config";
import "./tagdelivery.css";

const TagDelivery = ({
  match,
  location,
  getTagDelivery,
  materialData,
  tags,
  getTags,
  allData,
  postTagDelivery,
  updateStatus,
  getSiteInspect,
  generateReport,
  getPocBySiteId,
  pocListBySiteId,
  siteData,
  postSendReportMail,
 getSiteData,
 siteDetails,
 calculateDistance,
 engDistanceData,
 getDistanceData,
 distanceDetails
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [formData, setFormData] = useState({
    site_id: match.params.id,
    remark: '',
    data: [],
    newData: [],
  });
  const [isFiled, setIsFiled] = useState(false);
  const [addMore, setAddMore] = useState(0);
  const [isModal, setIsModal] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [statusModal, setStatusModal] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isDefalut, setIsDefalut] = useState(false);
  const openHideModal = () => setOpenModal(false);
  const [poclist, setPocList] = useState([]);
  const [showOtherEmail, setShowOtherEmail] = useState(false);
  const [mailList, setMailList] = useState([]);
  const [otherEmail, setOtherEmail] = useState();
  const [modal, setModal] = useState(false);
  const emailModalHide = () => setModal(false);
  const [showComplete, setShowComplete] = useState(false);
  const [showSubmit, setShowSubmit] = useState(false);
  const [isRecQntyValid, setIsRecQntyValid] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const [siteId, setSiteId] = useState('');
  const [inputList, setInputList] = useState([{ tag_type:"",quantity: "", unit_price: "",status:"" }]);
  const [tagsData, setTagData] = useState();
  const [isTarget, setIsTarget] = useState('');
  const [role, setRole] = useState('');
  const [opened, setIsOpened] = useState(false);
  const [isFreeze, setIsFreeze] = useState(false);
  const [salesRemarks, setSalesRemarks] = useState('');

  useEffect(() => {
    let roles = JSON.parse(localStorage.getItem('roles'))
    setRole(roles[0]?.id)
    setIsOpen(!isOpen);
  }, [])

  useEffect( () => {
    (async () => {
      await getDistanceData(match.params.id, 'tag-delivery')
    })()
  }, [])

  useEffect( () => {
    setIsOpen(true)
    if(distanceDetails !== {} && Object.keys(distanceDetails).length > 0){
      if(!distanceDetails['total_hours']){
        setIsOpen(false);
      }
    }
  }, [distanceDetails])


  useEffect( () => {
    if(engDistanceData !== null && Object.keys(engDistanceData).length > 0){
      toast.success('Distance is successfully fetched');
      setIsOpen(false);
      Object.keys(engDistanceData).forEach(key => {
        delete engDistanceData[key];
      })
    }else if(engDistanceData === null){
      toast.success('Distance is not fetched');
      setIsOpen(true);
    }
  }, [engDistanceData])

    //   // handle input change
    const handleInputChange = (e, index) => {
      const { name, value } = e.target;
      const list = [...inputList];
      list[index][name] = value;
      setInputList(list);
    };
    const handledropDownChange = (e, index,name) => {
      const { value,id} = e;
      const list = [...inputList];
      list[index][name] = id;
      if(id == 'Free'){
        list[index]['unit_price'] = 0;
      }
      setInputList(list);
    };
    
    // handle click event of the Remove button
    const handleRemoveClick = index => {
      const list = [...inputList];
      list.splice(index, 1);
      setInputList(list);
    };
    // handle click event of the Add button
    const handleAddClick = () => {
      setInputList([...inputList, {tag_type:"", quantity: "", unit_price: "",status:"" }]);
    };





  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await getTags(match.params.id);
      setIsLoading(false);
    })();
  }, [match.params.id]);

  useEffect(() => {
    if (getTagDelivery !== null && match.params.id);
    (async () => {
      setIsLoading(true);
      await getTagDelivery(match.params.id);
      // await getTags(match.params.id);
      await getSiteInspect(match.params.id, match.params.stageId);
      await getPocBySiteId(match.params.id);
      setIsLoading(false);
    })();
  }, [getTagDelivery, match.params.id]);

  

  // useEffect(() => {
  //   (async () => {
  //     if (
  //       siteData &&
  //       siteData.hasOwnProperty('report_url') &&
  //       location.state?.status === 'Completed'
  //     ) {
  //       if (siteData.report_url === '') {
  //         const data = {
  //           site_id: match.params.id,
  //           stage_id: match.params.stageId,
  //         };
  //         setIsLoading(true);
  //         const res = await generateReport(data);
  //         setIsLoading(false);
  //         await getSiteInspect(match.params.id, match.params.stageId);
  //       }
  //     }
  //   })();
  // }, [siteData]);


  const handleSubmit = async () => {
    if (
      formData.site_id === '' ||
      formData.data.length <= 0 ||
      (formData && formData.data && formData.data[0].quantity === '')
    ) {
      setIsFiled(true);
      setIsModal(false);
    } else {
      setIsLoading(true);
      
      // const res = await postTagDelivery([formData,inputList]);
      const { data } = await axios.post(Config.installation.postTagDelivery, [formData,inputList]);
      setIsLoading(false);
      if (data?.status && data?.status === true) {
        setIsModal(true);
        if (data?.status_code && data?.status_code == 101) {
          setIsFreeze(true);
        }
        // setIsError(false);
        // getTagDelivery(match.params.id);
      } else setIsError(true);
    }
  };

  const handleMaterialData = (val) => {
    if (val !== undefined && val !== null) {
      if (formData.data && formData.data.length === 0) {
        formData.data.push(val);
        setFormData({
          ...formData,
          data: [...formData.data],
        });
      } else {
        const isThere = formData.data.findIndex(
          (obj) => (obj.material_id === val.material_id && obj.price === val.price )
        );
        if (isThere === -1) {
          formData.data.push(val);
          setFormData({
            ...formData,
            data: [...formData.data],
          });
        } else {
          formData.data.splice(isThere, 1);
          formData.data.push(val);
          setFormData({
            ...formData,
            data: [...formData.data],
          });
        }
      }
    }
  };

  const handleModalHide = () => {
    setIsModal(false);
    setIsDefalut(true);
  };

  const setToDefaultValue = () => {
    if (isDefalut === true) {
      setFormData({
        ...formData,
        site_id: '',
        remark: '',
        data: [],
        newData: [],
      });
    }
  };

  useEffect(() => setToDefaultValue(), [isDefalut]);

  const handleStatusUpdate = async () => {
    const res = await updateStatus(match.params.id, match.params.stageId);
    if (res === true) {
      setStatusModal(true);
    }
  };

  const sendMail = (val) => {
    if (val) {
      setOpenModal(true);
    }
  };

  const sendMailPoc = async () => {
    const findIndex =
      mailList &&
      mailList.length > 0 &&
      mailList.findIndex((el) => el === 'Others');
    if (findIndex !== -1) {
      mailList.splice(findIndex, 1);
      mailList.push(otherEmail);
      setMailList([...mailList]);
    }
    const data = {
      stage_id: match.params.stageId,
      site_id: match.params.id,
      pocs: mailList,
    };
    if (data.pocs.length > 0) {
      setIsLoading(true);
      const res = await postSendReportMail(data);
      setIsLoading(false);
      if (res === true) {
        openHideModal();
        setModal(true);
      }
    }
  };

 

  useEffect(() => {
    let count = 0;
    if (materialData?.site_tags && materialData?.site_tags.length > 0) {
      if (materialData?.checkMismatch && materialData?.checkMismatch == 1) {
        setIsFreeze(true);
      } else {
        setIsFreeze(false);
      }
      setSalesRemarks('');
      if (materialData?.remarks) {
        setSalesRemarks(materialData?.remarks);
      }
      materialData?.site_tags.map((obj) => {
        if (Number(obj.requested_quantity) <= Number(obj.receive_quantity)) {
          count++;
        }
      });
      if (count === materialData?.site_tags.length) {
        setShowComplete(true);
      }
    }
  }, [materialData]);

  useEffect(() => {
    const list =
      poclist && poclist.length > 0 && poclist.map((element) => element['id']);
    setMailList(list);
  }, [poclist]);

  const headerBtns = () => {
    return (
      <Fragment>
        {showComplete ? (
          <Button
            className="btn btn-primary"
            onClick={() => handleStatusUpdate()}
          >
            {localization.stageCompleted}
          </Button>
        ) : (
          <>
            {isFreeze === true &&
              <label className={`error d-block freeze-text`}>
                Data sent for approval
              </label>
            }
          <Button onClick={() => handleSubmit()} disabled={isFreeze} className="btn btn-primary">
            {localization.submit}
          </Button>
          </>
        )}
      </Fragment>
    );
  };

  useEffect(() => {
    if (materialData?.site_tags && materialData?.site_tags.length > 0) {
      materialData?.site_tags.map((obj) => {
        if (Number(obj.qty) != Number(obj.receive_qty)) {
          setShowSubmit(true);
        }
      });
    }
  }, [materialData]);

  const handleFirstTime = () => {
    setAddMore(1);
  }

  return (
    <Layout
      title={localization.tagDelivery}
      Buttons={
        location.state && location.state.status !== 'Completed' && headerBtns
      }
      className={isFiled ? 'requiredFileds' : ''}
      isGoback
      linkFlag={true}
      linkUrl={`/dashboard/site-stage/${match.params.id}`}
      isLoading={isLoading}
    >

      {role === 9 && isOpen && opened ?
          <div className="popup-box">
            <div className="box">
              {siteDetails?.lead_id !== undefined &&
              <Link
                to={`${baseUrl}/site-stage/${match.params.id}/${siteDetails?.lead_id}`}
                className="btn btn-primary mb-4"
                style={{'cursor': 'pointer','border':'0px','box-shadow':'none !important','position':'relative','top':'-17px',
                  'float':'right'}}
            >
              x
            </Link>
              }

              <DistanceCalculator
                  siteData={siteDetails}
                  getSiteData={getSiteData}
                  calculateDistance={calculateDistance}
                  siteId={match.params.id}
                  moduleType={'tag-delivery'}
                  to={`${baseUrl}/site-stage/${match.params.id}/${siteDetails?.lead_id}`}
              />
            </div>
          </div> :
          <>
          <FormSection title={localization.material}>
            <div className="panel-body">
              {showSubmit === true && (
                  <Fragment>
                    <>
                    {salesRemarks !== '' &&
                      <label className={`error d-block freeze-text sales-remark`}>
                        Sales Rejection Remarks: {salesRemarks}
                      </label>
                    }
                    </>

                    <ConstantInput
                        label={localization.remarks}
                        isStarRequired={false}
                        handleChange={(val) => {
                          setFormData({
                            ...formData,
                            remark: val,
                          });
                        }}
                        disabled={isFreeze}
                        // required
                        errorMsg={localization.isRequired}
                    />
                    <table className="panel-table faq-listing">
                      <thead>
                      <tr>
                        <th>{localization.tags}</th>
                        <th>{localization.unitPrice}</th>
                        <th>{localization.requestedQuantity}</th>
                        {/*<th>{localization.deliveredQuantity}</th>*/}
                        {showSubmit === true && (
                            <th>{localization.receiveQuantity}</th>
                        )}
                      </tr>
                      </thead>
                      <tbody>
                      {materialData?.site_tags &&
                          materialData?.site_tags.length > 0 &&
                          materialData?.site_tags.map((obj, index) => {
                            return (
                                <tr key={index}>
                                  <td>
                                    <span className="th">{localization.productName}</span>
                                    {obj.name}
                                  </td>
                                  <td>
                                    <span className="th">{localization.productCode}</span>
                                    {obj.price}
                                  </td>
                                  <td>
                          <span className="th">
                            {localization.requestedQuantity}
                          </span>
                                    {obj.qty}
                                  </td>
                                  {/*<td>
                          <span className="th">
                            {localization.receiveQuantity}
                          </span>
                                    {obj.receive_qty}
                                  </td>*/}

                                  <td>

                                            <Fragment>
                                              <ConstantInput
                                                  required
                                                  // isStarRequired={true}
                                                  type="number"
                                                  min={1}
                                                  // max={
                                                  //   obj.requested_quantity - obj.receive_quantity
                                                  // }
                                                  errorMsg={
                                                    isError
                                                        ? localization.quatityGreaterMsg
                                                        : localization.isRequired
                                                  }
                                                  handleChange={(val) => {
                                                    const data = {
                                                      material_id: obj.tag_type,
                                                      quantity: val,
                                                      price: obj.price,
                                                    };
                                                    handleMaterialData(data);
                                                  }}
                                                  value={obj.receive_qty}
                                                  disabled={isFreeze}
                                              />
                                              {isRecQntyValid && (
                                                  <label className={`error d-block`}>
                                                    {isRecQntyValid}
                                                  </label>
                                              )}
                                            </Fragment>

                                  </td>
                                </tr>
                            );
                          })}
                      <tr>
                        {/*<td colSpan="5">*/}
                        {/*  <label className={`error ${isError ? 'd-block' : ''}`}>*/}
                        {/*    {localization.quatityGreaterMsg}*/}
                        {/*  </label>*/}
                        {/*</td>*/}
                      </tr>
                      </tbody>
                    </table>
                    {addMore !== 1 &&
                        <>
                          <br/>
                          <button className="btn btn-sm btn-primary" onClick={handleFirstTime} disabled={isFreeze}>Add More</button>
                        </>
                    }

                  </Fragment>

              )}

              {showSubmit === false && (
                  <Fragment>

                    <table className="panel-table faq-listing">
                      <thead>
                      <tr>
                        <th>{localization.tags}</th>
                        <th>{localization.unitPrice}</th>
                        <th>{localization.requestedQuantity}</th>
                        <th>{localization.deliveredQuantity}</th>
                        {showSubmit === true && (
                            <th>{localization.receiveQuantity}</th>
                        )}
                      </tr>
                      </thead>
                      <tbody>
                      {materialData?.site_tags &&
                          materialData?.site_tags.length > 0 &&
                          materialData?.site_tags.map((obj, index) => {
                            return (
                                <tr key={index}>
                                  <td>
                                    <span className="th">{localization.productName}</span>
                                    {obj.name}
                                  </td>
                                  <td>
                                    <span className="th">{localization.productCode}</span>
                                    {obj.price}
                                  </td>
                                  <td>
                          <span className="th">
                            {localization.requestedQuantity}
                          </span>
                                    {obj.qty}
                                  </td>
                                  <td>
                          <span className="th">
                            {localization.receiveQuantity}
                          </span>
                                    {obj.receive_qty}
                                  </td>


                                </tr>
                            );
                          })}

                      </tbody>
                    </table>


                  </Fragment>

              )}


            </div>

          </FormSection>



        <Fragment>
      {addMore === 1 && (
        <FormSection title={localization.tags}>
      {inputList.map((x, i) => {
        return (
        <div className="row">
        <div className="col-5">
        <DropDownInput
        data={tags}
        label={localization.tags}
        required
        isStarRequired={true}
        errorMsg={localization.tags}
        getIdValue={(val) =>{
        setTagData({
        ...tagsData,
        tag_type: val.id,
      });
        handledropDownChange(val,i,'tag_type');
      }
      }

        // onChange={e => handleInputChange(e, i)}
        />
        </div>
        <div className="col-5">
        <input
        className="form-control"
        name="quantity"
        placeholder="Receive Quantity"
        value={x.quantity}
        onChange={e => handleInputChange(e, i)}
        />
        </div>

        <div className="col-5">
        <DropDownInput

        label={localization.status}
        data={[
      {id: 'Free', name: 'Free'},
      {id: 'Paid', name: 'Paid'},
        ]}
        required
        errorMsg={localization.status}
        getIdValue={(val) =>{
        setTagData({
        ...tagsData,
        tag_type: val.id,
      });
        handledropDownChange(val,i,'status');
      }
      }
        // onChange={e => handleInputChange(e, i)}

        isStarRequired={true}
        />

        </div>
        <div className="col-5">
      {x.status && x.status == 'Paid' && (

        <input
        className="form-control"
        name="unit_price"
        placeholder="Unit Price"
        value={x.unit_price}
        onChange={e => handleInputChange(e, i)}
        />

        )}
        </div>
        <div className="btn-box">
      {inputList.length !== 1 && <button
        className="mr10"
        onClick={() => handleRemoveClick(i)} className="btn btn-sm btn-danger">Remove</button>}
      {inputList.length - 1 === i && <button className="btn btn-sm btn-primary" onClick={handleAddClick}>Add</button>}
        </div>
        </div>
        );
      })}


        </FormSection>

        )}

        </Fragment>

        <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
        >
        <div className="text-center">
        <div className="success">
        <img src={Images?.tick} alt="" />
        </div>
        <h5>{(isFreeze === true) ? localization.tagSendForApproval : localization.preB2bSuccess}</h5>
        <Link
        to={`${baseUrl}/site-stage/${match.params.id}`}
        className="btn btn-primary mb-4"
        >
      {localization.viewSiteStages}{' '}
        <img src={Images?.ArrowRight} alt="" />
        </Link>
        </div>
        </ModalPop>
        <ModalPop
        title={localization.conf}
        show={statusModal}
        handleModalHide={() => {
        setStatusModal(false);
      }}
        keyboard
        backdrop
        >
        <div className="text-center">
        <div className="success">
        <img src={Images?.tick} alt="" />
        </div>
        <h5>{localization.stateUpdateSuccess}</h5>
        <Link
        to={`${baseUrl}/site-stage/${match.params.id}`}
        className="btn btn-primary mb-4"
        >
      {localization.viewSiteStages}{' '}
        <img src={Images?.ArrowRight} alt="" />
        </Link>
        </div>
        </ModalPop>
        <ModalPop
        title={localization.notify}
        show={openModal}
        handleModalHide={openHideModal}
        keyboard
        backdrop
        >
        <div className="text-center">
        <DropDownInput
        multipule
        label={localization.toName}
        data={pocListBySiteId}
        required
        isStarRequired={true}
        errorMsg={localization.isRequired}
        getIdValue={(val) => {
        setPocList(val);
      }}
        />
      {showOtherEmail && (
        <ConstantInput
        label={localization.emailAddress}
        regex={Regex.email.test(otherEmail)}
        errorMsg={localization.emailError}
        handleChange={(val) => {
        setOtherEmail(val);
      }}
        type="text"
        />
        )}
        <Button
        className="btn btn-primary mb-4"
        onClick={() => {
        sendMailPoc();
      }}
        >
      {localization.submit} <img src={Images?.ArrowRight} alt="" />
        </Button>
        </div>
        </ModalPop>

        <ModalPop
        title={localization.conf}
        show={modal}
        handleModalHide={emailModalHide}
        keyboard
        backdrop
        >
        <div className="text-center">
        <div className="success">
        <img src={Images?.tick} alt="" />
        </div>
        <h5>{localization.mailSuccessfully}</h5>
        </div>
        </ModalPop>
          </>
      }
    </Layout>
  );
};
export default TagDelivery;
